import React from 'react';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

import styles from './IncomingFiles.styles';
import PageLoader from '../../../../components/loaders/PageLoader';

import IncomingFilesHeader from '../../components/IncomingFiles/IncomingFilesHeader';
import IncomingFilesFilters from '../../components/IncomingFiles/IncomingFilesFilters';
import IncomingFilesTable from '../../components/IncomingFiles/IncomingFilesTable';

import { useIncomingFiles } from '../../hooks/useIncomingFiles';

export default function IncomingFiles() {
  const { isSidebarExpanded } = useOutletContext();

  const {
    loading,
    searchQuery, setSearchQuery,
    dateRange, setDateRange,
    statusView, setStatusView,
    subStatusView, setSubStatusView,
    filters, setFilters,
    rows,
    fileNameOptions,
    dataProviderOptions,
  } = useIncomingFiles();

  return (
    <Box
      sx={{
        ...styles.fileContent,
        marginLeft: isSidebarExpanded ? '240px' : '95px',
        width: isSidebarExpanded ? 'calc(100vw - 240px)' : 'calc(100vw - 95px)',
        transition: 'all 0.3s ease',
      }}
    >
      {loading ? (
        <PageLoader />
      ) : (
        <>
          <IncomingFilesHeader
            title="Incoming Transmission File Log"
            onSearch={() => {}}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
          />

          <IncomingFilesFilters
            filters={filters}
            setFilters={setFilters}
            dateRange={dateRange}
            setDateRange={setDateRange}
            statusView={statusView}
            setStatusView={setStatusView}
            subStatusView={subStatusView}
            setSubStatusView={setSubStatusView}
            fileNameOptions={fileNameOptions}
            dataProviderOptions={dataProviderOptions}
          />

          <IncomingFilesTable rows={rows} />
        </>
      )}
    </Box>
  );
}
